import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Archive } from "lucide-react";
import { api, errMsg } from "../../lib/api";
import { Button } from "../ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from "../ui/dialog";

export function ArchiveCompanyButton({ cid, name }) {
  const nav = useNavigate();
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);
  const run = async () => {
    setBusy(true);
    try { await api.post(`/admin/companies/${cid}/archive`, { archived: true }); toast.success(`${name} foi arquivada`); nav("/backoffice/arquivadas"); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (<>
    <button type="button" onClick={() => setOpen(true)} className="inline-flex items-center gap-1 text-xs text-slate-500 font-medium hover:text-rose-700 transition-colors" data-testid="client-home-archive"><Archive className="h-3.5 w-3.5" />Arquivar empresa</button>
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent data-testid="archive-company-dialog">
        <DialogHeader><DialogTitle>Arquivar {name}?</DialogTitle>
          <DialogDescription>A empresa sai da Central de Clientes e os usuários dela ficam sem acesso ao Portal Empresa. Todos os dados, demandas, arquivos e históricos ficam guardados em "Arquivadas", e você pode restaurar quando quiser.</DialogDescription></DialogHeader>
        <DialogFooter><Button variant="outline" onClick={() => setOpen(false)} data-testid="archive-company-cancel">Cancelar</Button>
          <Button onClick={run} disabled={busy} data-testid="archive-company-confirm">{busy ? "Arquivando..." : "Arquivar empresa"}</Button></DialogFooter>
      </DialogContent>
    </Dialog>
  </>);
}
